module.exports = __webpack_public_path__ + "img/19.5e51086a.svg";